import React, { useState } from 'react';
import './ProjectPreview.css';

// Browser-frame preview for a project. Falls back to a stylised mock
// when the screenshot is missing or fails to load.
const ProjectPreview = ({ project, size = 'md' }) => {
  const [imageFailed, setImageFailed] = useState(false);
  const showImage = project.image && !imageFailed;

  return (
    <div className={`preview preview-${size}`}>
      <div className="preview-bar" aria-hidden="true">
        <span className="preview-dots">
          <i />
          <i />
          <i />
        </span>
        <span className="preview-url">{project.domain || project.title}</span>
      </div>
      <div className="preview-screen">
        {showImage ? (
          <img
            src={project.image}
            alt={`Screenshot of ${project.title}`}
            loading="lazy"
            onError={() => setImageFailed(true)}
          />
        ) : (
          <div className="preview-mock" aria-hidden="true">
            <div className="mock-nav">
              <span className="mock-logo" />
              <span className="mock-links">
                <i />
                <i />
                <i />
              </span>
            </div>
            <div className="mock-hero">
              <span className="mock-title">{project.client || project.title}</span>
              <span className="mock-line" />
              <span className="mock-line short" />
              <span className="mock-btn" />
            </div>
            <div className="mock-cards">
              <i />
              <i />
              <i />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectPreview;
